import $ from 'jquery';
import JQueryView from '@/common/views/jqueryView';

export default class PageView extends JQueryView {
  lastScrollTop: number; //スクロールが上か下か判定する基準点

  constructor() {
    super('#sb-site');

    this.lastScrollTop = 0;

    this.scrollShowBanner();
    this.scrollHideHeader();
  }

  scrollShowBanner() {
    const $floatingInview = $('.js-floating-inview');

    if ($floatingInview.length === 0) return;

    $(window).scroll(() => {
      if (window.scrollY > 100) {
        $floatingInview.addClass('is-show');
      } else {
        $floatingInview.removeClass('is-show');
      }
    });
  }

  scrollHideHeader() {
    const $header = $('.js-scroll-hidden-header');

    if ($header.length === 0) return;

    $(window).scroll(() => {
      const currentScrollTop = window.scrollY;

      if (currentScrollTop > this.lastScrollTop && currentScrollTop > 100) {
        // 下スクロール → 非表示
        $header.addClass('is-hidden');
      } else {
        // 上スクロール → 表示
        $header.removeClass('is-hidden');
      }

      this.lastScrollTop = currentScrollTop;
    });
  }
}
